module.exports = __webpack_public_path__ + "static/banner-right-img-3-c800fe02437054ab4c1192143a617e78.png";